import React from 'react';

import { Card, Group, Stack, Text } from '@mantine/core';
import { camelCaseToTitleCaseText } from 'utils/formatters';

import { useStyles } from '../styles';
import { CardTypes } from '../types';

interface IFlowBuilderCardProps {
  selectedOption: string | undefined | null;
  placeholderText: string;
  onCardSelect: (cardType: CardTypes) => void;
  cardType: CardTypes;
  children?: React.ReactNode;
  cardStyle?: string;
  disabled?: boolean;
}

const FlowBuilderCard = ({
  selectedOption,
  placeholderText,
  onCardSelect,
  cardType,
  children,
  cardStyle,
  disabled = false,
}: IFlowBuilderCardProps): JSX.Element => {
  const { classes } = useStyles();

  return (
    <Stack spacing='xs' align='flex-end' style={{ maxWidth: '400px', margin: '0 auto' }}>
      <Text color='dimmed' style={{ fontSize: '12px', textTransform: 'lowercase', alignSelf: 'flex-start' }}>
        {selectedOption && cardType && camelCaseToTitleCaseText(cardType)}
      </Text>
      <Group position='center' style={{ width: '100%' }}>
        <Card
          className={cardStyle ? cardStyle : classes.clickableCard}
          shadow='sm'
          padding='md'
          radius='md'
          withBorder
          onClick={() => {
            if (!disabled) onCardSelect(cardType);
          }}
          style={{ width: '100%' }} // Ensure the Card takes the full width of the Group
        >
          <Group position='center'>
            {children}
            <Text>{selectedOption ? selectedOption : placeholderText}</Text>
          </Group>
        </Card>
      </Group>
    </Stack>
  );
};

export default FlowBuilderCard;
